
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Search from 'vux/src/components/search/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

import imgup from '@/assets/upload_img.png'
import icoCurrent from '@/assets/flow-ico-current.png'
import icoPoint from '@/assets/ico-point.png'
import { getDealDetail, getFlow, getUserList, appoint, backAppoint, auditPass, auditUnpass, getLeadList, askleader } from '@/api/youzheng.js'
import { getSex } from '@/api/sys.js'
import { getConfig, addFile } from '@/api/wx.js'
import Storage from '@/storage'
import store from '@/store'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
name: 'myMailDetail',
data () {
return {
upimagelist: [],
imgcount: 5,
fileList: { fileUrlArr: [], fileIdArr: [] },
imgup: imgup,
icoCurrent: icoCurrent,
icoPoint: icoPoint,
id: this.$route.params.id,
obj: {
id: '',
statusNAME: '',
typeNAME: '',
linkername: '',
mobile: '',
sexidNAME: '',
idcard: '',
age: '',
companyname: '',
station: '',
linkeremail: '',
cityidNAMEE: '',
address: '',
title: '',
content: '',
fileldList: ''
},
flowlist: [],
accounttype: this.$store.state.user.personObj.accounttype,
isqyb: this.$store.state.user.personObj.isqyb,
popupShow: false,
askPopupShow: false,
searchValue: '',
askSearchValue: '',
namelist: [],
askNamelist: [],
radioModel: '',
askRadioModel: '',
popupBack: false,
backReason: '',
assignedReason: '',
askAssignedReason: '',
popupAudit: false,
auditReason: '',
baseUrl: config.baseUrl,
showToast: false,
previewSrc: '',
select: this.$route.params.select
}
},
components: {
Popup,
Group,
Cell,
XInput,
Selector,
PopupRadio,
XAddress,
XTextarea,
XSwitch,
Flexbox,
FlexboxItem,
XButton,
Tabbar,
TabbarItem,
Flow,
FlowState,
FlowLine,
Search,
XDialog
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
getDetail () {
getDealDetail({
accountid: this.accountid,
id: this.id
}).then(res => {
this.obj = res.returnValue
})
},
flow () {
getFlow({
accountid: this.accountid,
id: this.id,
page: 1,
rows: 999
}).then(res => {
this.flowlist = res.returnValue.list
})
},
reply (id) {
this.$router.push({ name: 'myReply', params: { id: id } })
},
replyOthoer (id) {
this.$router.push({ name: 'myReplyOther', params: { id: id } })
},

assigned () {
this.popupShow = true
},

searchChange () {
setTimeout(() => {
if (this.searchValue != '') {
getUserList({
name: this.searchValue,
page: 1,
rows: 10
}).then(res => {
if (res.returnValue && res.returnValue.length > 0) {
this.namelist = []
res.returnValue.forEach((item, index) => {
this.namelist.push({
label: item.name,
value: item.accountid,
isChecked: false
})





})
} else {

}
})
} else {
this.namelist = []
}
}, 600)
},
searchCancel () {
this.namelist = []
},
selectName (index) {

this.namelist.forEach((item) => {
item.isChecked = false
})

this.radioModel = this.namelist[index].value

this.namelist[index].isChecked = true
this.searchValue = this.namelist[index].label
},

cancel () {
this.searchValue = ''
this.namelist = ''
this.popupShow = false
},

sure () {
if (this.radioModel == '' || this.searchValue == '' || this.searchValue == '未查询到指派人员') {
this.$vux.toast.text('请选择指派人员', 'middle')
} else {
appoint({
accountid: this.accountid,
id: this.id,
zpperson: this.radioModel,
content: this.assignedReason
}).then(res => {
this.$vux.toast.text('操作成功', 'middle')
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 1 } })
})
}
},

askAction () {
this.askPopupShow = true
},

askSearchChange () {
setTimeout(() => {
if (this.askSearchValue != '') {
getLeadList({
name: this.askSearchValue,
page: 1,
rows: 10
}).then(res => {
if (res.returnValue && res.returnValue.length > 0) {
this.askNamelist = []
res.returnValue.forEach((item, index) => {
this.askNamelist.push({
label: item.name,
value: item.accountid,
isChecked: false
})
})
}
})
} else {
this.askNamelist = []
}
}, 600)
},
askSearchCancel () {
this.askNamelist = []
},
askSelectName (index) {

this.askNamelist.forEach((item) => {
item.isChecked = false
})

this.askRadioModel = this.askNamelist[index].value

this.askNamelist[index].isChecked = true
this.asSearchValue = this.askNamelist[index].label
},

askCancel () {
this.askSearchValue = ''
this.askNamelist = ''
this.askPopupShow = false
},

askSubmit () {
if (this.askRadioModel == '' || this.askSearchValue == '' || this.askSearchValue == '未查询到请示人员') {
this.$vux.toast.text('请选择请示人员', 'middle')
} else {
askleader({
accountid: this.accountid,
id: this.id,
zpperson: this.askRadioModel,
content: this.askAssignedReason
}).then(res => {
this.$vux.toast.text('操作成功', 'middle')
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 1 } })
})
}
},

goback (id) {
this.popupBack = true
},

backcancel () {
this.popupBack = false
this.backReason = ''
},

backsure () {
if (this.backReason !== '') {
backAppoint({
accountid: this.accountid,
id: this.id,
content: this.backReason
}).then(res => {
this.$vux.toast.text('操作成功', 'middle')
this.$router.push({ name: 'myMailWorkQyDaiban', params: { selected: 2, tabIndex: 1 } })
})
} else {
this.$vux.toast.text('请输入回退原因', 'middle')
}
},
audit () {
this.popupAudit = true
this.auditReason = ''
},

auditPass () {
if (this.auditReason !== '') {
auditPass({
accountid: this.accountid,
id: this.id,
auditmsg: this.auditReason
}).then(res => {
this.$vux.toast.text('操作成功', 'middle')
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 1 } })
})
} else {
this.$vux.toast.text('请输入批示意见', 'middle')
}
},

auditNopass () {
if (this.auditReason !== '') {
auditUnpass({
accountid: this.accountid,
id: this.id,
auditmsg: this.auditReason
}).then(res => {
this.$vux.toast.text('操作成功', 'middle')
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: 1 } })
})
} else {
this.$vux.toast.text('请输入审核原因', 'middle')
}
},

preview (src) {
this.showToast = true
this.previewSrc = src
}
},
activated () { },
created () {
this.getDetail()
this.flow()
}
}
